import { useTranslation } from 'react-i18next';
import { Box, Divider, Button } from '@mui/material';
import { useState, useCallback, useEffect } from 'react';
import { District } from 'src/shared/models/district/district';
import { Association } from 'src/shared/models/association/association';
import { UserStatusEnum } from 'src/shared/models/enums/userStatus.enum';
import { useGlobals } from 'src/shared/contexts/appContext';
import SearchField from 'src/shared/components/form/searchField';
import { PersonAdd } from '@mui/icons-material';
import { getPermission } from 'src/shared/functions/getSysProductPermissions';
import { PermissionEnum } from 'src/shared/models/enums/permissionEnums';
import { UserDataGrid } from '../components/userDataGrid';
import { UserCreateModal } from '../components/userCreateModal';

export const UserListPage = () => {
  const [, setLoading] = useState(false);

  const { setDateStamp, currentUser } = useGlobals();

  const [searchString, setSearchString] = useState<string>('');
  const [tempSearchString, setTempSearchString] = useState<string>('');
  const [association] = useState<Association>();
  const [district] = useState<District>();
  const [status] = useState<number[]>([UserStatusEnum.Active]);

  const [createMode, setCreateMode] = useState<boolean>(false);

  const { t } = useTranslation(['user']);

  const loadingCallback = useCallback((isLoading: boolean) => {
    setLoading(isLoading);
  }, []);

  const handleSave = () => {
    setDateStamp(new Date());
    setCreateMode(false);
  };

  useEffect(() => {
    if (tempSearchString === '') {
      setSearchString('');
    }
    if (tempSearchString.length >= 2) {
      setSearchString(tempSearchString);
    } else {
      setSearchString('');
    }
  }, [tempSearchString]);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            p: 2,
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
          }}
        >
          <SearchField onSearch={(newSearchString) => setTempSearchString(newSearchString)} />
        </Box>
        {getPermission(currentUser, PermissionEnum.UserCreate) && (
          <Box sx={{ p: 2 }}>
            <Button onClick={() => setCreateMode(true)} variant='contained' color='primary' startIcon={<PersonAdd />} disableElevation>
              {t('user:createNewUserButton')}
            </Button>
          </Box>
        )}
      </Box>
      <Divider />
      {status.length > 0 && (
        <UserDataGrid
          loadingCallback={loadingCallback}
          searchString={searchString}
          associationId={association?.countyAss_id.toString()}
          districtId={district?.countyAss_id.toString()}
          status={status}
          disableOnClickRow={!getPermission(currentUser, PermissionEnum.UserUpdate)}
        />
      )}
      {createMode && <UserCreateModal onClose={() => setCreateMode(false)} onSave={() => handleSave()} modalOpen={createMode} />}
    </>
  );
};
